import React from "react";
import { ConsultantEditorStore } from "./ConsultantEditorStore";

export const ConsultantEditorContext = React.createContext<ConsultantEditorStore>(null);

export function useConsultantEditorContext() {
  return React.useContext(ConsultantEditorContext);
}
